import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { StickyMobileBar } from "@/components/site/StickyMobileBar";
import { Reveal } from "@/components/site/Reveal";
import { company } from "@/data/content";

const Section = ({ eyebrow, title, children }) => (
  <Reveal className="border-t border-border py-10 first:border-t-0 first:pt-0">
    {eyebrow && (
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
        {eyebrow}
      </p>
    )}
    {title && (
      <h2 className="mt-3 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
        {title}
      </h2>
    )}
    <div className="mt-5 max-w-3xl space-y-4 text-base leading-relaxed text-muted-foreground">
      {children}
    </div>
  </Reveal>
);

export default function CookiesPage() {
  const today = new Date().toLocaleDateString("cs-CZ");
  return (
    <div className="min-h-screen bg-background" data-testid="cookies-page">
      <Navbar />
      <main className="pt-24 lg:pt-28">
        <section className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-24">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
            Právní informace
          </p>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            Zásady používání souborů cookies
          </h1>
          <p className="mt-4 max-w-2xl text-base text-muted-foreground">
            Tato stránka vysvětluje, jaké soubory cookies a obdobné technologie
            náš web používá a k čemu slouží.
          </p>

          <div className="mt-14">
            <Section eyebrow="1" title="Co jsou cookies">
              <p>
                Cookies jsou krátké textové soubory, které se ukládají ve
                Vašem prohlížeči při návštěvě webových stránek. Slouží
                k zajištění základních funkcí webu a případně k jeho měření
                nebo personalizaci.
              </p>
            </Section>

            <Section eyebrow="2" title="Jaké cookies používáme">
              <p>
                Web{" "}
                <strong className="text-foreground">{company.name}</strong>{" "}
                používá pouze <strong className="text-foreground">technicky nezbytné</strong>{" "}
                cookies a lokální úložiště prohlížeče, které jsou potřeba
                pro správné fungování stránek (například zachování stavu
                formulářů během vyplňování). Tyto cookies nevyžadují Váš
                souhlas.
              </p>
              <p>
                <strong className="text-foreground">
                  Nepoužíváme reklamní ani analytické cookies třetích stran
                </strong>{" "}
                (např. Google Analytics, Meta Pixel apod.). Pokud v budoucnu
                takové nástroje nasadíme, aktualizujeme tyto zásady a nejprve
                si vyžádáme Váš souhlas.
              </p>
            </Section>

            <Section eyebrow="3" title="Externí obsah a služby">
              <p>
                Při odeslání poptávkového formuláře jsou údaje zpracovány
                naším backendem a mohou být přeneseny do našich provozních
                nástrojů — zejména Google Sheets (evidence poptávek) a e-mailové
                služby doručující zprávu na naši adresu. Tyto přenosy
                nezahrnují ukládání cookies do Vašeho prohlížeče.
              </p>
            </Section>

            <Section eyebrow="4" title="Jak cookies spravovat">
              <p>
                Ukládání cookies můžete kdykoli omezit nebo zakázat přímo
                v nastavení svého prohlížeče (Chrome, Firefox, Safari,
                Edge). Můžete rovněž smazat již uložené cookies. Omezení
                technických cookies může vést k tomu, že některé části
                webu nebudou fungovat správně.
              </p>
            </Section>

            <Section eyebrow="5" title="Kontakt">
              <p>
                Máte-li dotaz ke zpracování cookies nebo k ochraně osobních
                údajů, napište nám na{" "}
                <a
                  href={company.emailHref}
                  className="text-foreground underline underline-offset-4 transition-colors hover:text-accent"
                >
                  {company.email}
                </a>
                .
              </p>
              <p className="text-sm">Aktuální znění platné od: {today}.</p>
            </Section>
          </div>

          <Link
            to="/"
            data-testid="cookies-back-home"
            className="mt-14 inline-flex items-center gap-2 text-sm font-semibold text-accent transition-colors hover:text-accent/80"
          >
            <ArrowLeft className="h-4 w-4" /> Zpět na hlavní stránku
          </Link>
        </section>
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
